import { Browser } from "@capacitor/browser";
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useLocation } from "react-router-dom";

import { PageMetaMap } from "../constants";

/**
 * @deprecated Although no more references to this page are present in the code base,
 * leaving this component in case there is a deep link to this page. Please directly
 * link to the "Terms of Conditions" page instead of using this component.
 */
const HelpDetailsPage = () => {
  //Used to open terms of policy by default
  const defaultMeta = "terms";

  const location: any = useLocation();
  const [title, url] = [
    location.state?.title || PageMetaMap.get(defaultMeta)?.title,
    location.state?.url || PageMetaMap.get(defaultMeta)?.url,
  ];

  return (
    <IonPage>
      <IonHeader no-border>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/home/account" mode="ios" />
          </IonButtons>
          <IonTitle style={{ marginLeft: "8px" }}>{title}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonItem button onClick={() => Browser.open({ url })} detail>
          <IonLabel>
            <h4>{title}</h4>
          </IonLabel>
        </IonItem>
      </IonContent>
    </IonPage>
  );
};

export default HelpDetailsPage;
